import React from 'react';
import Svg, { Circle, Rect } from 'react-native-svg';
import theme from 'shared/styles/theme';

interface RadioIconProps {
  selected: boolean;
}

const RadioIcon = ({ selected = false }: RadioIconProps) => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={theme.color.interactive.inverse}
    >
      <Rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        fill={theme.color.interactive.inverse}
      />
      <Rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke={theme.color.interactive.primary}
      />
      <Circle
        cx="12"
        cy="12"
        r="8"
        fill={
          selected
            ? theme.color.interactive.primary
            : theme.color.interactive.inverse
        }
      />
    </Svg>
  );
};

export default RadioIcon;
